import { Box, FormControl, Select, styled } from "@mui/material";

import { themePalette } from "../../theme";

type LanguageSwitcherVariant = "compact" | "settings";

interface LanguageSwitcherStyleProps {
  $variant?: LanguageSwitcherVariant;
}

export const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== "$variant",
})<LanguageSwitcherStyleProps>(({ $variant = "compact" }) => ({
  minWidth: $variant === "settings" ? 180 : 120,
  "& .MuiSelect-select": {
    fontSize: $variant === "settings" ? "16px" : "12px",
    padding: $variant === "settings" ? "10px 14px" : "4px 8px",
    color:
      $variant === "settings" ? themePalette.greyDark : themePalette.greyMedium,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor:
      $variant === "settings"
        ? themePalette.greenMedium
        : themePalette.greyLight,
  },
  "& .MuiSelect-icon": {
    color:
      $variant === "settings"
        ? themePalette.greenDark
        : themePalette.greyMedium,
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: themePalette.greenMedium,
  },
}));

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== "$variant",
})<LanguageSwitcherStyleProps>(({ $variant = "compact" }) => ({
  height: $variant === "settings" ? "42px" : "28px",
  "& .MuiSelect-select": {
    paddingTop: $variant === "settings" ? "10px" : "4px",
    paddingBottom: $variant === "settings" ? "10px" : "4px",
  },
}));

export const LanguageSwitcherWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$variant",
})<LanguageSwitcherStyleProps>(({ $variant = "compact" }) => ({
  display: "flex",
  alignItems: "center",
  gap: $variant === "settings" ? "16px" : "8px",
  marginTop: $variant === "settings" ? "20px" : 0,
  marginBottom: "8px",
}));

export const LanguageSwitcherLabel = styled("span")(() => ({
  color: themePalette.neutral700,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  textTransform: "uppercase",
}));
